import { render, staticRenderFns } from "./TableCustomForm.vue?vue&type=template&id=e00880a0&"
import script from "./TableCustomForm.vue?vue&type=script&lang=js&"
export * from "./TableCustomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports